<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex">
          <label
            class="col-form-label control-label ts-uppercase ts-font-bold text-primary"
          >
            {{ $t('pickupDisplay.pickupLists') }}
          </label>
          <ts-button
            class="ml-2"
            :disabled="!checkedStudent.length > 0 || priorityCallWaiting"
            color="primary"
            size="sm"
            @click.prevent="priorityCallMultiple"
            :waiting="priorityCallWaiting"
          >
            <i class="fas fa-user-check" v-if="!priorityCallWaiting"></i>
            {{ $t('pickupDisplay.priorityCall') }}
          </ts-button>
          <ts-button
            class="ml-2"
            :disabled="!checkedStudent.length > 0 || acknowledgeWaiting"
            color="warning"
            size="sm"
            @click.prevent="acknowledgeMultiple"
            :waiting="acknowledgeWaiting"
          >
            <i class="fas fa-user-tag" v-if="!acknowledgeWaiting"></i>
            {{ $t('pickupDisplay.acknowledge') }}
          </ts-button>
          <div class="ts-flex-grow"></div>
          <ts-button
            class="mr-2"
            :disabled="loading"
            color="info"
            outline
            size="sm"
            @click.prevent="fetchData"
            :waiting="loading"
          >
            <i class="fas fa-redo" v-if="!loading"></i>
            {{ $t('pickupDisplay.refresh') }}
          </ts-button>
          <div>
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :showCheckbox="true"
          @check-items="checkItem"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td class="with-img" width="2%">
              <img
                class="height-50 ts-rounded"
                v-lazy="{
                  src: studentPhoto(record),
                  error: onErrorStudent(record),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }"
              />
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.student.card_number }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.student.full_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.grade ? record.grade.grade_name_foreign : '' }}
            </td>
            <td class="with-img" width="2%">
              <img
                class="height-50 ts-rounded"
                v-lazy="{
                  src: guardianPhoto(record),
                  error: onError(record),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }"
              />
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.guardian.card_number }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.guardian.guardian }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.guardian.relationship }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <a-popconfirm
                placement="leftTop"
                :title="$t('user.are_you_sure_to_update')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @cancel="record.is_priority = !record.is_priority"
                @confirm="priorityCall(record)"
                class="mr-2"
                v-tooltip="$t('pickupDisplay.priorityCall')"
              >
                <a-switch
                  :loading="record._deleting"
                  v-model="record.is_priority"
                />
              </a-popconfirm>
              <a
                href="#"
                v-tooltip="$t('pickupDisplay.acknowledge')"
                @click.prevent="acknowledge(record)"
                class="text-warning"
              >
                <i class="fas fa-user-tag fa-2x"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('cancel')"
                @click.prevent="onCancelPickup(record)"
                class="text-danger ml-2"
              >
                <i class="far fa-window-close fa-2x"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'student-pickup-list',
  props: ['studentPickupLoad'],
  data () {
    return {
      loading: false,
      priorityCallWaiting: false,
      acknowledgeWaiting: false,
      manPhoto: require('../../assets/staff-default-man.png'),
      womenPhoto: require('../../assets/staff-default-women.png'),
      defaultPhoto: require('../../assets/user_default.png'),
      boyPhoto: require('../../assets/student-default-boy.png'),
      girlPhoto: require('../../assets/student-default-girl.png'),
      checkedStudent: []
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('pickupDisplay', ['resources', 'pagination']),
    columns () {
      return [
        {
          name: this.$t('pickupDisplay.branch'),
          sortKey: 'branch.branch_name_en'
        },
        {
          name: this.$t('pickupDisplay.photo')
        },
        {
          name: this.$t('pickupDisplay.cardNumber'),
          sortKey: 'student.card_number',
          style: 'text-align:center'
        },
        {
          name: this.$t('pickupDisplay.studentName'),
          sortKey: 'student.full_name_en'
        },
        {
          name: this.$t('pickupDisplay.grade'),
          sortKey: 'grade.grade_name_foreign'
        },
        {
          name: this.$t('pickupDisplay.photo')
        },
        {
          name: this.$t('pickupDisplay.cardNumber'),
          sortKey: 'guardian.card_number',
          style: 'text-align:center'
        },
        {
          name: this.$t('pickupDisplay.guardianName'),
          sortKey: 'guardian.guardian'
        },
        {
          name: this.$t('pickupDisplay.relationship'),
          sortKey: 'guardian.relationship',
          style: 'text-align:center'
        },
        { name: this.$t('actions'), style: 'text-align:center;width: 2%' }
      ]
    },
    search: {
      get () {
        return this.$store.state.pickupDisplay.search
      },
      set (newValue) {
        this.$store.commit('pickupDisplay/SET_SEARCH', newValue)
        this.$store.commit('pickupDisplay/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('pickupDisplay/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(errors => {
          this.loading = false
          this.$toasted.error(errors.message)
        })
    },
    studentPhoto (record) {
      if (record.student.photo) {
        return record.student.photo
      }
      if (record.student.gender == 'Male') {
        return this.boyPhoto
      }
      if (record.student.gender == 'Female') {
        return this.girlPhoto
      }

      return this.defaultPhoto
    },

    guardianPhoto (record) {
      if (record.guardian.photo) {
        return record.guardian.photo
      }
      if (record.guardian.relationship == 'Father') {
        return this.manPhoto
      }
      if (record.guardian.relationship == 'Mother') {
        return this.womenPhoto
      }

      return this.defaultPhoto
    },

    onError (record) {
      if (event) {
        if (record.guardian.relationship == 'Father') {
          event.target.src = this.manPhoto
        }
        if (record.guardian.relationship == 'Mother') {
          event.target.src = this.womenPhoto
        }
        if (record.guardian.relationship == 'Other') {
          event.target.src = this.defaultPhoto
        }
      }
    },
    onErrorStudent (record) {
      if (event) {
        if (record.student.gender == 'Male') {
          event.target.src = this.boyPhoto
        }
        if (record.student.gender == 'Female') {
          event.target.src = this.girlPhoto
        }
        if (record.student.gender == '') {
          event.target.src = this.defaultPhoto
        }
      }
    },
    async acknowledge (record) {
      if (
        await this.$confirmModal.danger(
          'Are you sure to acknowledge this student?'
        )
      ) {
        this.checkedStudent.push({
          student_id: record.student_id,
          picked_up_date: record.picked_up_date
        })
        record._deleting = true
        this.$store
          .dispatch('pickupDisplay/acknowledge', {
            student_lists: this.checkedStudent
          })
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
          .finally(() => {
            this.checkedStudent = []
          })
      }
    },
    async acknowledgeMultiple () {
      if (
        await this.$confirmModal.danger(
          'Are you sure to acknowledge selected students?'
        )
      ) {
        this.acknowledgeWaiting = true
        this.$store
          .dispatch('pickupDisplay/acknowledge', {
            student_lists: this.checkedStudent
          })
          .then(response => {
            this.$store.commit('pickupDisplay/RESET_STATE')
            this.fetchData()
            this.$toasted.success(response.message)
            this.acknowledgeWaiting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.acknowledgeWaiting = false
          })
          .finally(() => {
            this.checkedStudent = []
          })
      }
    },
    async priorityCall (record) {
      this.checkedStudent.push({
        student_id: record.student_id,
        picked_up_date: record.picked_up_date,
        is_priority: record.is_priority
      })
      record._deleting = true
      this.$store
        .dispatch('pickupDisplay/priorityCall', {
          student_lists: this.checkedStudent
        })
        .then(response => {
          this.$store.commit('pickupDisplay/RESET_STATE')
          this.fetchData()
          this.$toasted.success(response.message)
          record._deleting = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          record._deleting = false
        })
        .finally(() => {
          this.checkedStudent = []
        })
    },
    async priorityCallMultiple () {
      this.priorityCallWaiting = true
      this.$store
        .dispatch('pickupDisplay/priorityCall', {
          student_lists: this.checkedStudent
        })
        .then(response => {
          this.fetchData()
          this.$toasted.success(response.message)
          this.priorityCallWaiting = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.priorityCallWaiting = false
        })
        .finally(() => {
          this.checkedStudent = []
        })
    },
    checkItem (value) {
      this.checkedStudent = []
      if (!_.isEmpty(value)) {
        value.forEach(element => {
          this.checkedStudent.push({
            student_id: element.student_id,
            picked_up_date: element.picked_up_date,
            is_priority: true
          })
        })
      }
    },
    async onCancelPickup(record) {
      if (await this.$confirmModal.danger('Are you sure to cancel ?')) {
        record._deleting = true
        this.$store
          .dispatch('pickupDisplay/cancelPickup', record.serial_card)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    studentPickupLoad: debounce(function () {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('pickupDisplay/RESET_STATE')
    next()
  }
}
</script>
<style scoped>
table td {
  vertical-align: middle !important;
}
</style>
